import { Text } from "@mantine/core";
import { CSSProperties } from "react";

interface RenderTextProps {
  text: string | number;
  isAmount?: boolean;
  color?: string;
  fontWeight?: number;
  style?: CSSProperties;
}

const RenderText = ({ text, isAmount, color, fontWeight, style }: RenderTextProps) => {
  return isAmount ? (
    <Text
      size="sm"
      weight={fontWeight ? fontWeight : 500}
      c={color ? color : "#44566C"}
      ta="end"
      style={{ whiteSpace: "nowrap", ...(style ? style : undefined) }}>
      {text}
    </Text>
  ) : (
    <Text size="sm" weight={fontWeight ? fontWeight : 500} c={color ? color : "#44566C"} w="max-content" style={style ? style : undefined}>
      {text}
    </Text>
  );
};

export default RenderText;
